var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"personal-accounts personal-accounts_open-menu"},[_c('PersonalAccountItem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }